'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');

/**
 * Accepts a media query string then uses like '(min-width: 768px)' the
 * [window.matchMedia](https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia) API to determine if it
 * matches with the current document.<br />
 * It also monitor the document changes to detect when it matches or stops matching the media query.<br />
 * Returns the validity state of the given media query.
 *
 */
var useMediaQuery = function (query) {
    var isBrowser = typeof window !== 'undefined';
    var _a = React.useState(isBrowser ? window.matchMedia(query).matches : false), matches = _a[0], setMatches = _a[1];
    React.useEffect(function () {
        if (isBrowser) {
            var media_1 = window.matchMedia(query);
            if (media_1.matches !== matches) {
                setMatches(media_1.matches);
            }
            var listener_1 = function () { return setMatches(media_1.matches); };
            media_1.addListener(listener_1);
            return function () { return media_1.removeListener(listener_1); };
        }
    }, [query]);
    return matches;
};

exports.useMediaQuery = useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map
